"use client";
import { filterPost } from "@/src/actions/post";
import { useEffect, useState } from "react";
import PostSkeleton from "../../app-items/loading/post-page.skeleton";
import PostCarouselAuto from "../post-carousel-auto";

export default function RelatedPosts({ filters }: any) {
  const [isLoading, setIsLoading] = useState(true);
  const [posts, setPosts] = useState<any>();

  useEffect(() => {
    const init = async () => {
      const category = filters?.categories?.split(",")[0];
      const res = await filterPost({ category, limit: 6, page: 1 });
      setIsLoading(false);
      if (res?.results) {
        setPosts(res.results || []);
      }
    };
    init();
  }, [filters]);

  return isLoading ? <PostSkeleton /> : <PostCarouselAuto posts={posts} />;
}
